
import SuccessResponseAlert from '@/components/SuccessResponseAlert.vue';
import get from 'lodash/get';
import { Component, Vue } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

import { ClaimCheck } from '@/models';

@Component({
	name: 'RequestModal',
	components: {
		SuccessResponseAlert,
	},
	computed: {
		...mapState('claimCheck', ['claimCheck', 'request']),
		...mapGetters('claimCheck', [
			'collectGuests',
			'collectHandicap',
			'terminals',
		]),
	},
	methods: {
		...mapMutations('claimCheck', [
			'setGuests',
			'setHandicap',
			'setTerminal',
		]),
		...mapActions('claimCheck', ['sendRequest']),
	},
})
export default class RequestModal extends Vue {
	// Vuex
	public claimCheck!: ClaimCheck;
	public collectGuests!: false;
	public collectHandicap!: false;
	public request!: {
		num_guests: null | number;
		is_handicap: boolean;
		terminal: any;
	};

	public terminals!: any[];
	public sendRequest!: (payload: any) => Promise<any>;
	public setGuests!: (guests: null | number) => void;
	public setHandicap!: (request: boolean) => void;
	public setTerminal!: (terminal: any) => void;

	public get numGuests(): null | number {
		return this.request.num_guests;
	}

	public set numGuests(value: null | number) {
		this.setGuests(value);
	}

	public get processedPayment(): boolean {
		return this.$store.state.processedPayment;
	}

	public get requestAssistance(): boolean {
		return this.request.is_handicap;
	}

	public set requestAssistance(value: boolean) {
		this.setHandicap(value);
	}

	public get hasTerminals(): boolean {
		return !!this.claimCheck.terminals && !!this.claimCheck.terminals.length;
	}

	public get isRequestOnly(): boolean {
		if (this.hasTerminals ||
			this.claimCheck.collect_num_guests ||
			this.claimCheck.collect_handicap
		) {
			return false;
		}

		return true;
	}

	public get isValid(): boolean {
		if (!this.request.terminal && this.hasTerminals) {
			return false;
		}

		if (this.claimCheck.collect_num_guests && !this.request.num_guests) {
			return false;
		}

		return true;
	}

	public decrementGuests() {
		this.numGuests = this.numGuests || 1;
		this.numGuests--;

		if (this.numGuests < 1) {
			this.numGuests = 1;
		}
	}

	public incrementGuests() {
		this.numGuests = this.numGuests || 0;
		this.numGuests++;
	}

	public reset() {
		this.setGuests(null);
		this.setHandicap(false);
		this.setTerminal(null);
		this.$store.commit('setProcessedPayment', false);
	}

	public updateTerminal(value: any) {
		this.setTerminal(value);
		this.$store.commit('setProcessedPayment', false);
	}

	public async handleRequest() {
		const payload = {
			...this.request,
			terminal: get(this.request, 'terminal.terminal', null),
			ticket: this.claimCheck.ticket,
			rate_type: this.claimCheck.rate_type,
			url: `/claim/${this.claimCheck.ticket}/request`,
		};

		const response = await this.sendRequest(payload);

		if (response && response.requested_time) {
			this.$emit('requested', response.requested_time);
		}

		this.$modal.hide('RequestModal');
	}
}
